import request from '@/axios/index.js'
const uri = '/user/lawTxt/'; 
export function pagingLawTxtList(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'pagingLawTxtList'
    })
}
export function getSignatoryByCondition(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'getSignatoryByCondition'
    })
}
export function protocolList(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'protocolList'
    })
}
export function signatureSave(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'signatureSave'
    })
}


// WEBPACK FOOTER //
// ./src/api/lawTxt.js